import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb } from '../../components'
import { Form } from './components'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Organization Profile',
    route: '/dashboard/profile'
  },
  {
    name: 'Contact & Location',
    route: '/dashboard/profile'
  },
]

const DashboardLocationForm = () => {
  const [form, setForm] = React.useState({
    registrationType: 'external',
    visibility: 'public'
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <DashboardLayout title="Contact & Location">
      <div className="hidden xl:block">
        <Breadcrumb routes={routes}/>
        <h1 className="text-4xl font-bold font-primary">
          Add New Location / Edit Location
        </h1>
        <hr className="mt-5 mb-8"/>
      </div>
      <div className="xl:w-2/3">
        <Form form={form} updateForm={updateForm}/>
      </div>
    </DashboardLayout>
  )
}

export { DashboardLocationForm }
